// TireCodeBlock.tsx simplified for pure classification codes only
"use client";

import React, { useState } from "react";
import { useTireReading } from "@/app/context/TireReadingContext";
import TireAdjustmentModal from "./TireAdjustmentModal";

interface TireCodeBlockProps {
  code: string;
}

const TireCodeBlock: React.FC<TireCodeBlockProps> = ({ code }) => {
  const {
    selected,
    confirmClassificationChange,
    initial,
    // setAdjustmentReason,
    // setAdjustedDepth,
    // approveReading,
  } = useTireReading();
  const isSelected = selected === code;
  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    if (initial && code !== initial) {
      setShowModal(true);
    } else {
      confirmClassificationChange(code);
    }
  };

  const handleConfirm = (
    reason: string,
    depth: number,
    width?: number,
    height?: number,
    rim?: number
  ) => {
    confirmClassificationChange(code, reason, depth, width, height, rim);
  };

  return (
    <>
      <div
        onClick={handleClick}
        className={`
          p-11 rounded-2xl shadow-md flex flex-col items-center justify-center cursor-pointer transition-all w-full h-auto
          ${
            isSelected
              ? "bg-[var(--granu-green)] text-white scale-102"
              : "bg-gray-100 hover:bg-gray-200"
          }
          ${code === "XX" ? "hover:bg-red-400" : ""}
          ${code === "XX" && isSelected ? "bg-red-400" : ""}
        `}
      >
        <pre className="text-6xl font-sans text-center">
          <code>{code}</code>
        </pre>
      </div>

      {showModal && (
        <TireAdjustmentModal
          initialDepth={2.0} // or derive this from props/context
          onClose={() => setShowModal(false)}
          onConfirm={handleConfirm}
        />
      )}
    </>
  );
};

export default TireCodeBlock;
